function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#414141",
  d: "M18.842 17.898l-4.526-4.526a.416.416 0 0 0-.298-.123h-.362A7.297 7.297 0 0 0 8.298 1 7.297 7.297 0 0 0 1 8.3a7.297 7.297 0 0 0 12.25 5.36v.359c0 .112.045.217.122.298l4.526 4.526a.421.421 0 0 0 .597 0l.347-.347a.421.421 0 0 0 0-.597zM8.298 14.474a6.171 6.171 0 0 1-6.175-6.176 6.171 6.171 0 0 1 6.175-6.175 6.171 6.171 0 0 1 6.176 6.175 6.171 6.171 0 0 1-6.176 6.176z"
});

var SvgSearchInline = function SvgSearchInline(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgSearchInline;